import React from 'react';
import TextField from '@mui/material/TextField';

type Props = {
  subIndex: string | string[];
  keyName: string;
  value: any; // you can refine this to string | number | object | (string | number)[] etc.
  isEdited?: boolean;
  handleInputChange?: (key: string, value: string) => void;
};

const FormatArrayComponent: React.FC<Props> = ({
  subIndex,
  keyName,
  value,
  isEdited = false,
  handleInputChange
}) => {
  const keys = Array.isArray(subIndex) ? subIndex : [subIndex];

  return (
    <li >
      <strong>{keyName}:</strong>
      {keys.map((key) => {
        const currentValue = Array.isArray(subIndex) ? value?.[key] : value;

        const isEmpty =
          currentValue === null ||
          currentValue === undefined ||
          currentValue === "NA" ||
          currentValue === "na" ||
          currentValue === "N.A" ||
          currentValue === "n.a" ||
          (Array.isArray(currentValue) && currentValue.length === 0);

        if (isEmpty) {
          return isEdited ? (
            <TextField
              key={key}
              variant="standard"
              fullWidth
              value={currentValue || ""}
              onChange={(e) => handleInputChange?.(key, e.target.value)}
              style={{ display: "block" }}
            />
          ) : (
            <div key={key}></div>
          );
        }

        if (Array.isArray(currentValue)) {
          const flatValues = currentValue.flat().filter(Boolean);
          const onlyNo = flatValues.every((item) => item === "No");
          const filteredValues = onlyNo ? ["No"] : flatValues.filter((item) => item !== "No");

          return (
            <div key={key}>
              {isEdited ? (
                filteredValues.map((item, index) => (
                  <TextField
                    key={index}
                    variant="standard"
                    fullWidth
                    defaultValue={item}
                    onChange={(e) =>
                      handleInputChange?.(`${key}[${index}]`, e.target.value)
                    }
                  />
                ))
              ) : (
                filteredValues.map((item, index) =>
                  index === 0 ? (
                    <span key={index}>{item}</span>
                  ) : (
                    <span
                      key={index}
                      style={{ display: "block", paddingLeft: "2em" }}
                    >
                      {item}
                    </span>
                  )
                )
              )}
            </div>
          );
        }

        // fallback if it's not empty and not an array
        return (
          <div key={key}>
            {isEdited ? (
              <TextField
                variant="standard"
                fullWidth
                value={currentValue || ""}
                onChange={(e) => handleInputChange?.(key, e.target.value)}
              />
            ) : (
              <span>{currentValue}</span>
            )}
          </div>
        );
      })}

    </li>
  );
};
const SubFormatArrayComponent: React.FC<Props> = ({
  subIndex,
  keyName,
  value,
  isEdited = false,
  handleInputChange
}) => {
  const keys = Array.isArray(subIndex) ? subIndex : [subIndex];

  return (
    <li style={{ marginLeft: "50px" }}>
      <strong>{keyName}:</strong>
      {keys.map((key) => {
        const currentValue = Array.isArray(subIndex) ? value?.[key] : value;

        const isEmpty =
          currentValue === null ||
          currentValue === undefined ||
          currentValue === "NA" ||
          currentValue === "na" ||
          currentValue === "N.A" ||
          currentValue === "n.a" ||
          (Array.isArray(currentValue) && currentValue.length === 0);

        if (isEmpty) {
          return isEdited ? (
            <TextField
              key={key}
              variant="standard"
              fullWidth
              value={currentValue || ""}
              onChange={(e) => handleInputChange?.(key, e.target.value)}
              style={{ display: "block" }}
            />
          ) : (
            <div key={key}></div>
          );
        }

        if (Array.isArray(currentValue)) {
          const flatValues = currentValue.flat().filter(Boolean);
          const onlyNo = flatValues.every((item) => item === "No");
          const filteredValues = onlyNo ? ["No"] : flatValues.filter((item) => item !== "No");

          return (
            <div key={key}>
              {isEdited ? (
                filteredValues.map((item, index) => (
                  <TextField
                    key={index}
                    variant="standard"
                    fullWidth
                    defaultValue={item}
                    onChange={(e) =>
                      handleInputChange?.(`${key}[${index}]`, e.target.value)
                    }
                  />
                ))
              ) : (
                filteredValues.map((item, index) => (
                  <React.Fragment key={index}>
                    {index === 0 ? (
                      item
                    ) : (
                      <span style={{ display: "block", paddingLeft: "2em" }}>
                        {item}
                      </span>
                    )}
                  </React.Fragment>
                ))
              )}
            </div>
          );
        }

        // ✅ fallback for non-empty, non-array values
        return (
          <div key={key}>
            {isEdited ? (
              <TextField
                variant="standard"
                fullWidth
                value={currentValue || ""}
                onChange={(e) => handleInputChange?.(key, e.target.value)}
              />
            ) : (
              <span>{currentValue}</span>
            )}
          </div>
        );
      })}

    </li>
  );
};


export {
  FormatArrayComponent,
  SubFormatArrayComponent
};
